let PACK_SELECTION = {};

function findGetParameter(parameterName) {
  var result = null,
    tmp = [];
  location.search
    .substr(1)
    .split("&")
    .forEach(function (item) {
      tmp = item.split("=");
      if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
    });
  return result;
}

if (document.querySelector("[data-popup-open]")) {
  document.querySelector("[data-popup-open]").addEventListener("click", (e) => {
    var popup = e.currentTarget.getAttribute("data-popup-open");
    document.querySelector(`[data-popup="${popup}"]`).classList.add("fade-in");
  });

  document.querySelector(".custom-popup").addEventListener("click", (e) => {
    document.querySelector(`[data-popup]`).classList.remove("fade-in");
  });
}

class PackItem extends HTMLElement {
  constructor() {
    super();

    // Check if the pack is the discover pack with the parameter in the url
    this.updateUrlDiscoverPack();

    this.all_packs_container = document.querySelectorAll("pack-item");
    this.updatePackContent();

    this.addEventListener("click", this.selectPack.bind(this));
    this.last_number_selection = 0;
    this.first_load = true;
    this.content_updated = false;
  }

  updateUrlDiscoverPack() {
    const discover_pack = findGetParameter("discover-pack");

    if (discover_pack == "true") {
      document.querySelectorAll("pack-item").forEach((pack) => {
        pack.classList.remove("actif");
      });

      document
        .querySelector('[data-discover-pack="true"]')
        .classList.add("actif");

      // remove params from current url
      const url = window.location.href;
      const new_url = url.split("?")[0];
      window.location.href.indexOf("/pages") <= -1
        ? window.history.pushState("page2", "Title", new_url)
        : null;
    }
  }

  selectPack(event) {
    const target = event.currentTarget;

    if (!this.classList.contains("actif")) {
      // get colors from dataset and set them as css variables
      const background_general = target.dataset.productBackgroundGeneral;
      const background_secondary = target.dataset.productBackgroundSecondary;

      // Last background general is used to animate the background transition from the last pack selected to the new one
      const last_background_general =
        document.documentElement.style.getPropertyValue(
          "--background-transition"
        );

      document.documentElement.style.setProperty(
        "--background-transition-last",
        last_background_general
      );
      document.documentElement.style.setProperty(
        "--background-transition",
        background_general
      );
      document.documentElement.style.setProperty(
        "--background-images",
        background_secondary
      );

      if (!DISABLE_VARIANT_ANIM) this.runBackgroundTransition();

      if (this.querySelector(".product-wave-bottom")) {
        this.querySelector(".product-wave-bottom").style.color =
          last_background_general;
      }

      this.all_packs_container.forEach((pack) => {
        pack.classList.remove("actif");
      });

      this.classList.add("actif");
      this.updatePackContent();

      if (document.querySelector(".product-pack__unit-price")) {
        document.querySelector(".product-pack__unit-price").innerHTML =
          "(" +
          document.querySelector(".product-pack__item.actif h4").innerHTML +
          ")";
      }
    }
  }

  runBackgroundTransition() {
    const background_container = document.querySelector(".product-transition");

    background_container.setAttribute(
      "style",
      "transform: translateX(-100%) !important"
    );

    let x = -100;

    // We use a setInterval to animate the background transition
    const interval = setInterval(function () {
      background_container.setAttribute(
        "style",
        `transform: translateX(${x}%) !important`
      );
      x += 0.8;
      if (window.innerWidth < 768) {
        x += 0.22;
      }
      if (x >= 0) {
        background_container.setAttribute(
          "style",
          `transform: translateX(0%) !important`
        );

        clearInterval(interval);
      }
    }, 1);
  }

  updatePackContent() {
    if (this.classList.contains("actif")) {
      this.last_multiplier_selection = PACK_SELECTION.smoothies_times
        ? PACK_SELECTION.smoothies_times
        : 1;

      if (this.dataset.discoverPack === "true") {
        document.querySelector('[data-filter-flavor="all"]').innerHTML = 'TOUS (7)';
        document
          .querySelector(".product-pack__selection")
          .classList.add("hidden");

        document.querySelectorAll(".subscribe_counter").forEach((btn) => {
          btn.classList.add("hidden");
        });

        document.querySelector('quantity-input-main').classList.remove("hidden");

        document.querySelector("[data-add-to-cart-button]").textContent = "Ajouter";

        let svg = '<svg xmlns="http://www.w3.org/2000/svg" class="custom-discovery-svg" width="28" height="22" viewBox="0 0 28 22" fill="none"><path fill-rule="evenodd" clip - rule="evenodd" d = "M0 4.53441C0 4.0664 0.381473 3.68701 0.852043 3.68701H3.91087C4.31352 3.68701 4.66121 3.96734 4.74449 4.35914L5.28504 6.90221H21.2438C21.5421 6.90221 21.8186 7.05731 21.9729 7.31114C22.1272 7.56497 22.1369 7.88058 21.9983 8.14326L17.5801 16.5198C17.433 16.7987 17.1423 16.9735 16.8256 16.9735H6.37481C5.97215 16.9735 5.62447 16.6932 5.54119 16.3014L3.22012 5.38181H0.852043C0.381473 5.38181 0 5.00242 0 4.53441ZM7.06556 15.2787H16.3104L19.8347 8.597H5.64529L7.06556 15.2787Z" fill = "white" /><path fill-rule="evenodd" clip-rule="evenodd" d="M7.85614 19.7732C7.85595 19.7736 7.85547 19.7747 7.85547 19.778C7.85547 19.7813 7.85595 19.7824 7.85614 19.7828L7.85616 19.7829C7.85656 19.7838 7.85752 19.7855 7.85934 19.7873C7.86116 19.7891 7.86285 19.7901 7.86381 19.7905L7.86386 19.7905C7.86429 19.7907 7.86542 19.7912 7.8687 19.7912C7.87198 19.7912 7.87311 19.7907 7.87354 19.7905L7.87358 19.7905C7.87455 19.7901 7.87623 19.7891 7.87805 19.7873C7.87987 19.7855 7.88083 19.7838 7.88124 19.7829L7.88126 19.7828C7.88144 19.7824 7.88192 19.7813 7.88192 19.778C7.88192 19.7747 7.88144 19.7736 7.88126 19.7732L7.88124 19.7731C7.88083 19.7722 7.87987 19.7705 7.87805 19.7687C7.87623 19.7669 7.87455 19.7659 7.87358 19.7655L7.87354 19.7655C7.87311 19.7653 7.87198 19.7648 7.8687 19.7648C7.86542 19.7648 7.86429 19.7653 7.86386 19.7655L7.86381 19.7655C7.86285 19.7659 7.86116 19.7669 7.85934 19.7687C7.85752 19.7705 7.85656 19.7722 7.85616 19.7731L7.85614 19.7732ZM6.14111 19.778C6.14111 18.8279 6.91458 18.0576 7.8687 18.0576C8.82282 18.0576 9.59628 18.8279 9.59628 19.778C9.59628 20.7281 8.82282 21.4984 7.8687 21.4984C6.91458 21.4984 6.14111 20.7281 6.14111 19.778Z" fill="white"/><path fill-rule="evenodd" clip-rule="evenodd" d="M15.0461 19.7732C15.0459 19.7736 15.0454 19.7747 15.0454 19.778C15.0454 19.7813 15.0459 19.7824 15.0461 19.7828L15.0461 19.7829C15.0465 19.7838 15.0475 19.7855 15.0493 19.7873C15.0511 19.7891 15.0528 19.7901 15.0538 19.7905L15.0538 19.7905C15.0542 19.7907 15.0554 19.7912 15.0586 19.7912C15.0619 19.7912 15.063 19.7907 15.0635 19.7905L15.0635 19.7905C15.0645 19.7901 15.0662 19.7891 15.068 19.7873C15.0698 19.7855 15.0708 19.7838 15.0712 19.7829L15.0712 19.7828C15.0714 19.7824 15.0719 19.7813 15.0719 19.778C15.0719 19.7747 15.0714 19.7736 15.0712 19.7732L15.0712 19.7731C15.0708 19.7722 15.0698 19.7705 15.068 19.7687C15.0662 19.7669 15.0645 19.7659 15.0635 19.7655L15.0635 19.7655C15.063 19.7653 15.0619 19.7648 15.0586 19.7648C15.0554 19.7648 15.0542 19.7653 15.0538 19.7655L15.0538 19.7655C15.0528 19.7659 15.0511 19.7669 15.0493 19.7687C15.0475 19.7705 15.0465 19.7722 15.0461 19.7731L15.0461 19.7732ZM13.3311 19.778C13.3311 18.8279 14.1045 18.0576 15.0586 18.0576C16.0128 18.0576 16.7862 18.8279 16.7862 19.778C16.7862 20.7281 16.0128 21.4984 15.0586 21.4984C14.1045 21.4984 13.3311 20.7281 13.3311 19.778Z" fill="white"/><ellipse cx="21.0939" cy="7.37566" rx="6.90595" ry="6.87713" fill="white"/><path d="M20.1984 10.5393V4.22949H21.9676V10.5393H20.1984ZM17.8257 8.21751V6.55129H24.3539V8.21751H17.8257Z" fill="#17433E"/></svg >';

        document.querySelector(".product-button__container .product-form__button.v2-button").innerHTML += svg;


        document.querySelectorAll('.product-button__count').forEach((btn) => {
          btn.classList.add("hidden");
        });

        document
          .querySelectorAll(
            '.product-pack__flavors--discover [data-action="increment"]'
          )
          .forEach((btn) => {
            btn.setAttribute("disabled", "disabled");
          });
      } else {
        document.querySelector('[data-filter-flavor="all"]').innerHTML = 'TOUS (10)';

        document.querySelector('quantity-input-main').classList.add("hidden");
        document.querySelector("[data-add-to-cart-button]").textContent = "Ajouter au panier";

        document.querySelector(".product-button__container .product-form__button.v2-button .custom-discovery-svg") ? document.querySelector(".product-button__container .product-form__button.v2-button .custom-discovery-svg").remove() : null;

        document.querySelectorAll(".subscribe_counter").forEach((btn) => {
          btn.classList.remove("hidden");
        });

        document.querySelectorAll('.product-button__count').forEach((btn) => {
          btn.classList.remove("hidden");
        });
      }


      // We update the pack selection object
      PACK_SELECTION = {
        discover_pack: this.dataset.discoverPack === "true" ? true : false,
        subtitle: this.dataset.productSubtitle,
        pack_id: parseInt(this.dataset.productId),
        pack_variant_id: parseInt(this.dataset.productVariantId),
        pack_name: this.dataset.productName,
        pack_price: parseFloat(this.dataset.productVariantPrice),
        pack_price_before: parseFloat(this.dataset.productVariantPriceBefore) ? parseFloat(this.dataset.productVariantPriceBefore) : null,
        selling_plan_id: document.querySelector(
          ".product-pack__recurring-select-values label.actif"
        )
          ? document.querySelector(
            ".product-pack__recurring-select-values label.actif"
          ).value
          : document.querySelector("[data-first-reccuring]").dataset
            .firstReccuring,
        pack_price_sub: parseFloat(this.dataset.productVariantPriceSub),
        smoothies_times:
          this.dataset.discoverPack === "true"
            ? PACK_SELECTION.smoothies_times
            : parseInt(this.dataset.smoothiesTimes),
        smoothies_number:
          this.dataset.discoverPack === "true"
            ? PACK_SELECTION.smoothies_number
            : parseInt(this.dataset.smoothiesNumber),
        pack_image: this.dataset.productImage,
        pack_items: PACK_SELECTION.pack_items ? PACK_SELECTION.pack_items : [],
      };

      document.querySelector(
        ".subscribe_counter [data-total-number]"
      ).textContent = PACK_SELECTION.smoothies_number;

      document.querySelector("[data-smoothies-multiplier]")
        ? (document.querySelector("[data-smoothies-multiplier]").innerHTML =
          PACK_SELECTION.smoothies_times)
        : null;

      if (document.querySelector('[data-product-title="Kit Découverte"]')) {
        if (PACK_SELECTION.discover_pack == false) {
          document
            .querySelector('[data-product-title="Kit Découverte"]')
            .classList.add("hidden");
          document
            .querySelector('[data-product-title="Pack Smoothies"]')
            .classList.remove("hidden");
        } else {
          document
            .querySelector('[data-product-title="Kit Découverte"]')
            .classList.remove("hidden");
          document
            .querySelector('[data-product-title="Pack Smoothies"]')
            .classList.add("hidden");
        }
      }

      if (PACK_SELECTION.pack_price_before != null && document.querySelector('.product-old-price-per-smoothie') == null) {
        document.querySelectorAll('pack-item').forEach((pack) => {
          let smoothies_number = pack.dataset.smoothiesNumber ? pack.dataset.smoothiesNumber : 7;
          let smoothies_price = pack.dataset.productVariantPriceBefore;

          let old_price = smoothies_price / smoothies_number;

          let span = document.createElement('span');
          span.innerHTML = old_price.toFixed(2) + "€";
          span.classList.add("product-old-price-per-smoothie");

          pack.querySelector('.product-pack__content .bogart').prepend(span);
        });
      }


      if (
        !document.querySelector('[data-subscribe="false"].actif') ||
        document.querySelector('[data-discover-pack="true"].actif')
      ) {
        document.querySelector(
          'pack-item:not([data-discover-pack="true"]) [data-unit-price-sub]'
        )
          ? document
            .querySelectorAll(
              'pack-item:not([data-discover-pack="true"]) [data-unit-price-sub]'
            )
            .forEach((price) => {
              price.classList.remove("hidden");
            })
          : null;
        document.querySelector(
          'pack-item:not([data-discover-pack="true"]) [data-unit-price-oneshot]'
        )
          ? document
            .querySelectorAll(
              'pack-item:not([data-discover-pack="true"]) [data-unit-price-oneshot]'
            )
            .forEach((price) => {
              price.classList.add("hidden");
            })
          : null;
      } else {
        document.querySelector(
          'pack-item:not([data-discover-pack="true"]) [data-unit-price-sub]'
        )
          ? document
            .querySelectorAll(
              'pack-item:not([data-discover-pack="true"]) [data-unit-price-sub]'
            )
            .forEach((price) => {
              price.classList.add("hidden");
            })
          : null;
        document.querySelector(
          'pack-item:not([data-discover-pack="true"]) [data-unit-price-oneshot]'
        )
          ? document
            .querySelectorAll(
              'pack-item:not([data-discover-pack="true"]) [data-unit-price-oneshot]'
            )
            .forEach((price) => {
              price.classList.remove("hidden");
            })
          : null;
      }

      console.log(PACK_SELECTION);

      this.updatePriceCta();

      this.updatePageContent();
    }
  }

  updatePageContent() {
    if (document.querySelector(".product-sub__top-bar")) {
      document.querySelector(".top-bar__image img").src =
        PACK_SELECTION.pack_image;
      document.querySelector(".top-bar__image img").classList.remove("fade-in");

      document.querySelector(".top-bar__image img").onload = function () {
        if (this.first_load == false)
          document
            .querySelector(".top-bar__image img")
            .classList.add("fade-in");
        this.first_load = false;
      };


      document.querySelector(".top-bar__image img").removeAttribute("srcset");

      document.querySelector(".top-bar__details .h3").innerHTML =
        PACK_SELECTION.pack_name;

      document.querySelector(".top-bar__recuring").innerHTML =
        document.querySelector(
          ".product-pack__recurring-select-values .actif"
        ).innerHTML;
    }

    // We update the page content
    document
      .querySelectorAll(".main-product-medias__card img")
      .forEach((item) => (item.src = PACK_SELECTION.pack_image));
    document
      .querySelectorAll(".main-product-medias__card img")
      .forEach((item) => item.classList.remove("fade-in"));

    document
      .querySelectorAll(".main-product-medias__card img")
      .forEach((item) => {
        item.onload = function () {
          if (this.first_load == false)
            document
              .querySelector(".main-product-medias__card img")
              .classList.add("fade-in");
          this.first_load = false;
        };
      });

    document
      .querySelectorAll(".main-product-medias__card img")
      .forEach((item) => item.removeAttribute("srcset"));
    document.querySelector(".main-product-form__title h1").innerHTML =
      PACK_SELECTION.pack_name;

    document.querySelector("[data-pack-selected]").innerHTML =
      PACK_SELECTION.pack_name;

    // We hide the pack composition part if the pack is the discover pack
    if (PACK_SELECTION.discover_pack) {
      document.querySelector(".product-pack__details h5").style.opacity = 0;
      document
        .querySelector(".product-pack__flavors--customize")
        .classList.add("hidden");
      document
        .querySelector(".product-pack__flavors--discover")
        .classList.remove("hidden");

      document.querySelector('[data-step="subscribe"]').classList.add("hidden");
      document
        .querySelector('[data-step="oneshot"]')
        .classList.remove("hidden");
    } else {
      document
        .querySelector('[data-step="subscribe"]')
        .classList.remove("hidden");
      document.querySelector('[data-step="oneshot"]').classList.add("hidden");
      document.querySelector(".product-pack__details h5").style.opacity = 1;
      document
        .querySelector(".product-pack__flavors--customize")
        .classList.remove("hidden");
      document
        .querySelector(".product-pack__flavors--discover")
        .classList.add("hidden");
    }

    if (document.querySelector(".main-product-form__subtitle"))
      document.querySelector(".main-product-form__subtitle").innerHTML =
        PACK_SELECTION.subtitle;

    // Update price and subscribe part because the discover pack is oneshot only
    this.updateDiscoverPack();

    if (!PACK_SELECTION.discover_pack) {
      const pack_input = document.querySelector(
        '.product-form__input input[value="Pack de ' +
        PACK_SELECTION.smoothies_number +
        ' Fruggies"]'
      );
      console.log(
        '.product-form__input input[value="Pack de ' +
        PACK_SELECTION.smoothies_number +
        ' Fruggies"]'
      );
      pack_input.nextElementSibling.click();
      this.updatePackComposition();
      this.updatePrice();
    }
    if (!PACK_SELECTION.discover_pack) {
      this.updatePriceCta();
    }
  }

  updatePriceCta() {
    const is_subscription = document.querySelector(
      '[data-subscribe="true"].actif'
    )
      ? true
      : false;

    if (PACK_SELECTION.pack_price_before != null) {
      document.querySelectorAll('.product-pack__recurring-price--old-before').forEach((price) => {
        price.classList.remove("hidden");
        price.innerHTML = PACK_SELECTION.pack_price_before.toFixed(2) + "€";
      });
    }

    if (is_subscription) {
      document.querySelector("[data-discover-price]").innerHTML =
        " <span>—</span> " + PACK_SELECTION.pack_price_sub.toFixed(2) + "€" + '<svg xmlns="http://www.w3.org/2000/svg" width="29" height="22" viewBox="0 0 29 22" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.5 4.78459C0.5 4.31659 0.881473 3.93719 1.35204 3.93719H4.41087C4.81352 3.93719 5.16121 4.21753 5.24449 4.60933L5.78504 7.15239H21.7438C22.0421 7.15239 22.3186 7.30749 22.4729 7.56132C22.6272 7.81516 22.6369 8.13076 22.4983 8.39344L18.0801 16.7699C17.933 17.0489 17.6423 17.2237 17.3256 17.2237H6.87481C6.47215 17.2237 6.12447 16.9434 6.04119 16.5516L3.72012 5.63199H1.35204C0.881473 5.63199 0.5 5.2526 0.5 4.78459ZM7.56556 15.5289H16.8104L20.3347 8.84719H6.14529L7.56556 15.5289Z" fill="white"/><path fill-rule="evenodd" clip-rule="evenodd" d="M8.35614 20.0235C8.35595 20.024 8.35547 20.0251 8.35547 20.0284C8.35547 20.0316 8.35595 20.0327 8.35614 20.0332L8.35616 20.0332C8.35656 20.0342 8.35752 20.0359 8.35934 20.0377C8.36116 20.0395 8.36285 20.0404 8.36381 20.0408L8.36386 20.0409C8.36429 20.041 8.36542 20.0415 8.3687 20.0415C8.37198 20.0415 8.37311 20.041 8.37354 20.0409L8.37358 20.0408C8.37455 20.0404 8.37623 20.0395 8.37805 20.0377C8.37987 20.0359 8.38083 20.0342 8.38124 20.0332L8.38126 20.0332C8.38144 20.0327 8.38192 20.0316 8.38192 20.0284C8.38192 20.0251 8.38144 20.024 8.38126 20.0235L8.38124 20.0235C8.38083 20.0225 8.37987 20.0209 8.37805 20.019C8.37623 20.0172 8.37455 20.0163 8.37358 20.0159L8.37354 20.0158C8.37311 20.0157 8.37198 20.0152 8.3687 20.0152C8.36542 20.0152 8.36429 20.0157 8.36386 20.0158L8.36381 20.0159C8.36285 20.0163 8.36116 20.0172 8.35934 20.019C8.35752 20.0209 8.35656 20.0225 8.35616 20.0235L8.35614 20.0235ZM6.64111 20.0284C6.64111 19.0782 7.41458 18.308 8.3687 18.308C9.32282 18.308 10.0963 19.0782 10.0963 20.0284C10.0963 20.9785 9.32282 21.7487 8.3687 21.7487C7.41458 21.7487 6.64111 20.9785 6.64111 20.0284Z" fill="white"/><path fill-rule="evenodd" clip-rule="evenodd" d="M15.5461 20.0235C15.5459 20.024 15.5454 20.0251 15.5454 20.0284C15.5454 20.0316 15.5459 20.0327 15.5461 20.0332L15.5461 20.0332C15.5465 20.0342 15.5475 20.0359 15.5493 20.0377C15.5511 20.0395 15.5528 20.0404 15.5538 20.0408L15.5538 20.0409C15.5542 20.041 15.5554 20.0415 15.5586 20.0415C15.5619 20.0415 15.563 20.041 15.5635 20.0409L15.5635 20.0408C15.5645 20.0404 15.5662 20.0395 15.568 20.0377C15.5698 20.0359 15.5708 20.0342 15.5712 20.0332L15.5712 20.0332C15.5714 20.0327 15.5719 20.0316 15.5719 20.0284C15.5719 20.0251 15.5714 20.024 15.5712 20.0235L15.5712 20.0235C15.5708 20.0225 15.5698 20.0209 15.568 20.019C15.5662 20.0172 15.5645 20.0163 15.5635 20.0159L15.5635 20.0158C15.563 20.0157 15.5619 20.0152 15.5586 20.0152C15.5554 20.0152 15.5542 20.0157 15.5538 20.0158L15.5538 20.0159C15.5528 20.0163 15.5511 20.0172 15.5493 20.019C15.5475 20.0209 15.5465 20.0225 15.5461 20.0235L15.5461 20.0235ZM13.8311 20.0284C13.8311 19.0782 14.6045 18.308 15.5586 18.308C16.5128 18.308 17.2862 19.0782 17.2862 20.0284C17.2862 20.9785 16.5128 21.7487 15.5586 21.7487C14.6045 21.7487 13.8311 20.9785 13.8311 20.0284Z" fill="white"/><ellipse cx="21.5939" cy="7.62591" rx="6.90595" ry="6.87713" fill="white"/><path d="M20.6984 10.7893V4.47949H22.4676V10.7893H20.6984ZM18.3257 8.46751V6.80129H24.8539V8.46751H18.3257Z" fill="#17433E"/></svg >';;
    } else {
      document.querySelector("[data-discover-price]").innerHTML =
        " <span>—</span> " + PACK_SELECTION.pack_price.toFixed(2) + "€" + '<svg xmlns="http://www.w3.org/2000/svg" width="29" height="22" viewBox="0 0 29 22" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.5 4.78459C0.5 4.31659 0.881473 3.93719 1.35204 3.93719H4.41087C4.81352 3.93719 5.16121 4.21753 5.24449 4.60933L5.78504 7.15239H21.7438C22.0421 7.15239 22.3186 7.30749 22.4729 7.56132C22.6272 7.81516 22.6369 8.13076 22.4983 8.39344L18.0801 16.7699C17.933 17.0489 17.6423 17.2237 17.3256 17.2237H6.87481C6.47215 17.2237 6.12447 16.9434 6.04119 16.5516L3.72012 5.63199H1.35204C0.881473 5.63199 0.5 5.2526 0.5 4.78459ZM7.56556 15.5289H16.8104L20.3347 8.84719H6.14529L7.56556 15.5289Z" fill="white"/><path fill-rule="evenodd" clip-rule="evenodd" d="M8.35614 20.0235C8.35595 20.024 8.35547 20.0251 8.35547 20.0284C8.35547 20.0316 8.35595 20.0327 8.35614 20.0332L8.35616 20.0332C8.35656 20.0342 8.35752 20.0359 8.35934 20.0377C8.36116 20.0395 8.36285 20.0404 8.36381 20.0408L8.36386 20.0409C8.36429 20.041 8.36542 20.0415 8.3687 20.0415C8.37198 20.0415 8.37311 20.041 8.37354 20.0409L8.37358 20.0408C8.37455 20.0404 8.37623 20.0395 8.37805 20.0377C8.37987 20.0359 8.38083 20.0342 8.38124 20.0332L8.38126 20.0332C8.38144 20.0327 8.38192 20.0316 8.38192 20.0284C8.38192 20.0251 8.38144 20.024 8.38126 20.0235L8.38124 20.0235C8.38083 20.0225 8.37987 20.0209 8.37805 20.019C8.37623 20.0172 8.37455 20.0163 8.37358 20.0159L8.37354 20.0158C8.37311 20.0157 8.37198 20.0152 8.3687 20.0152C8.36542 20.0152 8.36429 20.0157 8.36386 20.0158L8.36381 20.0159C8.36285 20.0163 8.36116 20.0172 8.35934 20.019C8.35752 20.0209 8.35656 20.0225 8.35616 20.0235L8.35614 20.0235ZM6.64111 20.0284C6.64111 19.0782 7.41458 18.308 8.3687 18.308C9.32282 18.308 10.0963 19.0782 10.0963 20.0284C10.0963 20.9785 9.32282 21.7487 8.3687 21.7487C7.41458 21.7487 6.64111 20.9785 6.64111 20.0284Z" fill="white"/><path fill-rule="evenodd" clip-rule="evenodd" d="M15.5461 20.0235C15.5459 20.024 15.5454 20.0251 15.5454 20.0284C15.5454 20.0316 15.5459 20.0327 15.5461 20.0332L15.5461 20.0332C15.5465 20.0342 15.5475 20.0359 15.5493 20.0377C15.5511 20.0395 15.5528 20.0404 15.5538 20.0408L15.5538 20.0409C15.5542 20.041 15.5554 20.0415 15.5586 20.0415C15.5619 20.0415 15.563 20.041 15.5635 20.0409L15.5635 20.0408C15.5645 20.0404 15.5662 20.0395 15.568 20.0377C15.5698 20.0359 15.5708 20.0342 15.5712 20.0332L15.5712 20.0332C15.5714 20.0327 15.5719 20.0316 15.5719 20.0284C15.5719 20.0251 15.5714 20.024 15.5712 20.0235L15.5712 20.0235C15.5708 20.0225 15.5698 20.0209 15.568 20.019C15.5662 20.0172 15.5645 20.0163 15.5635 20.0159L15.5635 20.0158C15.563 20.0157 15.5619 20.0152 15.5586 20.0152C15.5554 20.0152 15.5542 20.0157 15.5538 20.0158L15.5538 20.0159C15.5528 20.0163 15.5511 20.0172 15.5493 20.019C15.5475 20.0209 15.5465 20.0225 15.5461 20.0235L15.5461 20.0235ZM13.8311 20.0284C13.8311 19.0782 14.6045 18.308 15.5586 18.308C16.5128 18.308 17.2862 19.0782 17.2862 20.0284C17.2862 20.9785 16.5128 21.7487 15.5586 21.7487C14.6045 21.7487 13.8311 20.9785 13.8311 20.0284Z" fill="white"/><ellipse cx="21.5939" cy="7.62591" rx="6.90595" ry="6.87713" fill="white"/><path d="M20.6984 10.7893V4.47949H22.4676V10.7893H20.6984ZM18.3257 8.46751V6.80129H24.8539V8.46751H18.3257Z" fill="#17433E"/></svg >';
    }
  }

  updateDiscoverPack() {
    const recurring_option = document.querySelector(
      ".product-pack__recurring-options"
    );
    const oneshot_option = document.querySelector('[data-subscribe="false"]');
    const sub_option = document.querySelector('[data-subscribe="true"]');
    const oneshot_price = document.querySelector(
      ".product-pack__recurring-price--old"
    );
    const recurring_title = document.querySelector(
      ".product-pack__recurring-details"
    );
    const discover_price = document.querySelector("[data-discover-price]");

    if (PACK_SELECTION.discover_pack) {
      recurring_option.classList.add("hidden");

      if (document.querySelector(".product-pack__recurring-price--main")) {
        document
          .querySelector(".product-pack__recurring-price--main")
          .classList.add("hidden");
      }
      if (oneshot_option) {
        oneshot_option.click();
      } else {
        sub_option.click();
      }
      oneshot_price.innerHTML = PACK_SELECTION.pack_price + "€";
      recurring_title.classList.add("hidden");
      let discover_final_price = PACK_SELECTION.pack_price * Number(document.querySelector('quantity-input-main input').value);
      discover_price.innerHTML = " - " + discover_final_price.toFixed(2) + "€";
      if (document.querySelector(".top-bar__price")) {
        document.querySelector(".top-bar__price").innerHTML =
          " - " + PACK_SELECTION.pack_price.toFixed(2) + "€";
      }
      discover_price.classList.remove("hidden");
      document.querySelector(".product-ingredients")
        ? document
          .querySelector(".product-ingredients")
          .classList.remove("hidden")
        : null;
      window.location.href.indexOf("/pages") <= -1
        ? window.history.pushState({}, "", "/products/kit-decouverte")
        : 0;
    } else {
      document.querySelector(".product-ingredients")
        ? document.querySelector(".product-ingredients").classList.add("hidden")
        : null;
      recurring_option.classList.remove("hidden");
      oneshot_price.innerHTML = PACK_SELECTION.pack_price.toFixed(2) + "€";
      recurring_title.classList.remove("hidden");
      discover_price.classList.innerHTML = PACK_SELECTION.pack_price.toFixed(2) + "€";
      // update url with .products/pack-smoothies
      window.location.href.indexOf("/pages") <= -1
        ? window.history.pushState({}, "", "/products/pack-smoothies")
        : 0;
    }
  }

  updatePackComposition() {
    // We update the pack composition with the new multiplier value
    const quantity_input = document.querySelectorAll(
      ".product-pack__flavors--customize quantity-input"
    );
    let total = 0;

    for (const item of PACK_SELECTION.pack_items) {
      total += item.quantity;
    }

    if (total >= PACK_SELECTION.smoothies_number) {
      document.querySelectorAll('.product-button__count').forEach((btn) => {
        btn.classList.add("hidden");
      });
    }
    else {
      document.querySelectorAll('.product-button__count').forEach((btn) => {
        btn.classList.remove("hidden");
        btn.querySelector('[data-count-reste-fruggies]').innerHTML = PACK_SELECTION.smoothies_number - total;
      });
    }


    /* If the total is 0, it means that the pack has just been selected,
       so we set the quantity of each smoothie to the default value
    */

    if (document.querySelector(".product-pack__recurring-price--main")) {
      document
        .querySelector(".product-pack__recurring-price--main")
        .classList.remove("hidden");
    }
    if (total == 0) {
      /* We loop through each smoothie quantity input and set the value to the default value 
        REMOVE THIS PART ACTUALLY !!!
      */

      PACK_SELECTION.pack_items = [];

      quantity_input.forEach((input) => {
        if (input.closest(".product-pack__flavors--discover")) {
          return;
        }
        const value = 0;
        input.querySelector("input").value = PACK_SELECTION.smoothies_times;
        console.log(value);
        PACK_SELECTION.pack_items.push({
          flavor: input.querySelector("input").dataset.flavor,
          quantity: value,
          flavor_id:
            PACK_SELECTION.smoothies_times == 4
              ? parseInt(input.querySelector("input").dataset["flavorId-4"])
              : parseInt(input.querySelector("input").dataset["flavorId-5"]),
        });
        input.querySelector("input").value = value;
        total += PACK_SELECTION.smoothies_times;

        input.querySelector(".quantity-input__minus .not-disabled").innerHTML =
          "- " + PACK_SELECTION.smoothies_times;
        input.querySelector(".quantity-input__plus").innerHTML =
          "+ " + PACK_SELECTION.smoothies_times;
      });
    } else {
      /* If the total is not 0, it means that the composition
        pack has already been selected, so we update the quantity 
        of each smoothie with the new multiplier value
      */
      let current_total = 0;

      quantity_input.forEach((input) => {
        if (input.closest(".product-pack__flavors--discover")) {
          return;
        }
        console.log(current_total, PACK_SELECTION.smoothies_number);
        console.log(input);

        const value = parseInt(input.querySelector("input").value);
        const new_quantity =
          (value * PACK_SELECTION.smoothies_times) /
          this.last_multiplier_selection;

        if (current_total <= PACK_SELECTION.smoothies_number) {
          // We update the quantity of each smoothie with the new multiplier value
          input.querySelector("input").value = new_quantity;
          console.log(new_quantity);
          current_total += new_quantity;

          console.log(input.querySelector("input").dataset.flavor);
          console.log(new_quantity);
          console.log(
            value,
            PACK_SELECTION.smoothies_times,
            this.last_multiplier_selection
          );

          // We update the pack selection object
        }

        PACK_SELECTION.pack_items.forEach((item) => {
          if (item.flavor === input.querySelector("input").dataset.flavor) {
            if (current_total <= PACK_SELECTION.smoothies_number) {
              item.quantity = new_quantity;
              this.content_updated = true;
            } else {
              console.log("OVERFLOW -> " + item);
              input.querySelector("input").value = 0;
              item.quantity = 0;
            }
            item.flavor_id =
              PACK_SELECTION.smoothies_times == 4
                ? parseInt(input.querySelector("input").dataset["flavorId-4"])
                : parseInt(input.querySelector("input").dataset["flavorId-5"]);
          }
        });

        input.querySelector(".quantity-input__minus .not-disabled").innerHTML =
          "- " + PACK_SELECTION.smoothies_times;
        input.querySelector(".quantity-input__plus").innerHTML =
          "+ " + PACK_SELECTION.smoothies_times;

        if (input.querySelector("input").value == 0) {
          input
            .querySelector('[data-action="decrement"]')
            .setAttribute("disabled", "disabled");
        } else {
          input
            .querySelector('[data-action="decrement"]')
            .removeAttribute("disabled");
        }
      });
    }

    document
      .querySelector(".product-pack__flavors--customize quantity-input")
      .dispatchEvent(new Event("updateContent"));
  }

  updatePrice() {
    const price_subsave = document.querySelector("[data-price-subsave]");
    document
      .querySelectorAll(".product-pack__recurring-price--old")
      .forEach((price) => {
        price.innerHTML = PACK_SELECTION.pack_price.toFixed(2) + "€";
      });
    document
      .querySelectorAll(".product-pack__recurring-price--new")
      .forEach((price) => {
        price.innerHTML = PACK_SELECTION.pack_price_sub.toFixed(2) + "€";
      });

    if (document.querySelector(".top-bar__price")) {
      document.querySelector(".top-bar__price").innerHTML =
        " - " + PACK_SELECTION.pack_price_sub.toFixed(2) + "€";
    }
  }
}

customElements.define("pack-item", PackItem);

class PackForm extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector("form");

    this.submitBtn = this.querySelector(
      ".product-form__button:not(.product-form__button--flavors)"
    );

    this.querySelectorAll(".product-pack__flavor-navigation-item").forEach(
      (item) => {
        item.addEventListener("click", this.toggleFlavor.bind(this));
      }
    );

    this.submitBtn.addEventListener("click", this.submitForm.bind(this));

    document
      .querySelector(".selection-packs-upgrade__accept")
      .addEventListener("click", () => {
        document.querySelector('[data-smoothies-number="30"]').click();
        document
          .querySelector(".selection-packs-upgrade")
          .classList.remove("open");
      });

    document
      .querySelectorAll(".selection-packs-upgrade__decline")
      .forEach((button) => {
        button.addEventListener("click", () => {
          document
            .querySelectorAll(".selection-packs-upgrade")
            .forEach((item) => {
              item.classList.remove("open");
            });
        });

        document
          .querySelectorAll(".selection-packs-upgrade__decline")
          .forEach((button) => {
            button.addEventListener("click", () => {
              document
                .querySelectorAll(".selection-packs-upgrade")
                .forEach((item) => {
                  item.classList.remove("open");
                });
            });
          });
      });
  }

  toggleFlavor(event) {
    this.querySelectorAll(".product-pack__flavor-navigation-item").forEach(
      (item) => {
        item.classList.remove("actif");
      }
    );

    this.querySelectorAll(".product-pack__flavor").forEach((item) => {
      item.classList.add("hidden");
    });
    let tag = event.currentTarget.dataset.filterFlavor;
    event.currentTarget.classList.add("actif");
    if (tag === "all") {
      this.querySelectorAll(".product-pack__flavor").forEach((item) => {
        item.classList.remove("hidden");
      });
      event.currentTarget.classList.add("actif");
      return;
    }
    this.querySelectorAll(
      `.product-pack__flavor[data-flavor-tag="${tag}"]`
    ).forEach((item) => {
      item.classList.remove("hidden");
    });
  }

  submitForm(event) {
    event.preventDefault();

    if (PACK_SELECTION.discover_pack) {
      this.submitBtn.classList.add("loading");
      this.addDiscoverPackToCart();
      return;
    }

    // We get the total quantity of smoothies in the pack
    let total = 0;
    for (const item of PACK_SELECTION.pack_items) {
      total += item.quantity;
    }

    // We check if the total quantity is equal to the number of smoothies in the pack
    if (total === PACK_SELECTION.smoothies_number) {
      // Update Button, add loading state
      this.submitBtn.classList.add("loading");

      for (const item of PACK_SELECTION.pack_items) {
        // Set the variant size on recharge widget
        const id = item.flavor_id;
        const select_recharge = document
          .querySelector(`.rb-select [value="${id}"]`)
          .closest("select");
        console.log(`.rb-select [value="${id}"]`);
        select_recharge.value = id;
        select_recharge.dispatchEvent(new Event("change"));

        // Update bundle size on recharge widget
        const bundle_size_select = document
          .querySelector('.rb-select option[value="Pack de 20 Fruggies"]')
          .closest("select");
        bundle_size_select.value = `Pack de ${PACK_SELECTION.smoothies_number} Fruggies`;
        bundle_size_select.dispatchEvent(new Event("change"));

        // Update the quantity of the selected variant
        let input = select_recharge.closest(".tflex-column").nextElementSibling;
        if (input) {
          input = input.querySelector("input");
        } else {
          input = select_recharge.nextElementSibling.querySelector("input");
        }

        input.value = item.quantity / PACK_SELECTION.smoothies_times;
        input.dispatchEvent(new Event("change"));
      }

      setTimeout(this.submitBundle.bind(this), 400);
    } else {
      document.querySelector(".selection-packs-error").classList.add("open");
    }
  }

  addDiscoverPackToCart() {

    let quantity = Number(document.querySelector('quantity-input-main input[name="quantity"]').value);
    const data = {
      items: [
        {
          id: PACK_SELECTION.pack_variant_id,
          quantity: quantity,
        },
      ],
    };
    console.log(JSON.stringify(data));

    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        let _item = {
          Name: "Pack Smoothies",
          ProductID: 6801528750246,
          Categories: ["Pack Smoothies"],
          ImageURL:
            "https://fruggies.com/cdn/shop/products/0-PACK-DECOUVERTE-BASE_1_900x.png?v=1680280073",
          URL: "https://fruggies.com/products/kit-decouverte",
          Brand: "Fruggies",
          Price: "31.49 €",
          CompareAtPrice: "0,00 €",
        };
        _learnq.push(["track", "Added to Cart", _item]);
        console.log("TRACKING END");
        // add event submit on shopify-product-form
        document
          .querySelector(".shopify-product-form")
          .dispatchEvent(new Event("opencart"));
        this.submitBtn.classList.remove("loading");
      });
  }

  submitBundle() {
    const submitBtn = document.querySelector(".rb-container form button");
    submitBtn.click();

    this.addBottleToCart();
  }

  addBottleToCart() {
    if (document.querySelector(".rb-extras-sidebar")) {
      const bottle_id =
        document.querySelector("[data-bottle-id]").dataset.bottleId;
      const has_cart_bottle = document.querySelector(
        `[data-cart-id="${bottle_id}"]`
      );

      window.location.href =
        window.location.href.indexOf("?") > -1
          ? window.location.href + "&open=cart"
          : window.location.href + "?open=cart";
      this.submitBtn.classList.remove("loading");
    } else {
      setTimeout(() => {
        this.addBottleToCart();
      }, 500);
    }
  }
}

if (customElements.get("pack-form") === undefined) {
  customElements.define("pack-form", PackForm);
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();

    if (!this.closest(".product-pack__flavors--discover")) {
      this.input = this.querySelector('input[name="quantity"]');
      this.addEventListener("click", this.changeQuantity.bind(this));
      this.addEventListener("updateContent", this.changeQuantity.bind(this));
    }
    this.updateSmoothiesCounter();
  }

  changeQuantity(event) {
    const target = event.target;
    let total = 0;

    // Get the total quantity of smoothies in the pack
    for (const item of PACK_SELECTION.pack_items) {
      total += item.quantity;
    }

    const value = parseInt(this.input.value);

    if (target.classList.contains("quantity-input__btn")) {
      if (target.dataset.action === "increment") {
        if (total < PACK_SELECTION.smoothies_number) {
          target
            .closest("quantity-input")
            .querySelector('[data-action="decrement"]')
            .removeAttribute("disabled");
          // We update the input value with the new quantity
          this.input.value = value + PACK_SELECTION.smoothies_times;
        } else {
          if (PACK_SELECTION.smoothies_number == 20 && total == 20) {
            document
              .querySelector(
                ".selection-packs-upgrade:not(.selection-packs-error)"
              )
              .classList.add("open");
          }
        }
      } else if (target.dataset.action === "decrement") {
        if (value > 1) {
          // We update the input value with the new quantity
          this.input.value = value - PACK_SELECTION.smoothies_times;
          if (this.input.value == 0) {
            target.setAttribute("disabled", "disabled");
          }
        } else {
        }
      }
    }

    let total_smoothies = 0;

    let quantity_inputs = document.querySelectorAll(
      '.product-pack__flavors:not(.product-pack__flavors--discover) quantity-input [name="quantity"][data-flavor]'
    );

    for (const input of quantity_inputs) {
      total_smoothies += parseInt(input.value);
    }

    if (total_smoothies >= PACK_SELECTION.smoothies_number) {
      document.querySelectorAll('.product-button__count').forEach((btn) => {
        btn.classList.add("hidden");
      });
    }
    else {
      document.querySelectorAll('.product-button__count').forEach((btn) => {
        btn.classList.remove("hidden");
      });

      document.querySelectorAll('.product-button__count [data-count-reste-fruggies]').forEach((btn) => {
        btn.innerHTML = PACK_SELECTION.smoothies_number - total_smoothies;
      });
    }

    document.querySelector(
      ".subscribe_counter [data-current-number]"
    ).textContent = total_smoothies;

    console.log(total_smoothies);
    console.log(PACK_SELECTION.smoothies_number);

    if (
      PACK_SELECTION.smoothies_number == 30 &&
      PACK_SELECTION.smoothies_number == total_smoothies
    ) {
      document
        .querySelectorAll('quantity-input button[data-action="increment"]')
        .forEach((btn) => {
          btn.setAttribute("disabled", "disabled");
        });
    } else {
      document
        .querySelectorAll('quantity-input button[data-action="increment"]')
        .forEach((btn) => {
          btn.removeAttribute("disabled");
        });
    }

    if (
      PACK_SELECTION.smoothies_number == 60 &&
      PACK_SELECTION.smoothies_number == total_smoothies
    ) {
      document
        .querySelectorAll('quantity-input button[data-action="increment"]')
        .forEach((btn) => {
          btn.setAttribute("disabled", "disabled");
        });
    } else {
      document
        .querySelectorAll('quantity-input button[data-action="increment"]')
        .forEach((btn) => {
          btn.removeAttribute("disabled");
        });
    }

    this.updateSelectionContent();
    this.updateSelectionCard();
    this.updateSmoothiesCounter();
  }

  updateSelectionCard() {
    let selection_container = document.querySelector(
      ".main-product-form__form .product-pack__selection-details"
    );
    let smoothies = document.querySelectorAll(
      ".product-pack__flavors--customize quantity-input [data-flavor]"
    );

    let total = 0;
    for (const smoothie of smoothies) {
      let quantity = smoothie.value;

      if (quantity >= 0) {
        total += parseInt(quantity);
      }
    }

    console.log(total);

    selection_container.innerHTML = `<span>Saveurs sélectionnées [${total}/${PACK_SELECTION.smoothies_number}]</span>: `;
    document.querySelector(".product-pack__selection").classList.add("hidden");

    for (const smoothie of smoothies) {
      let quantity = smoothie.value;
      let flavor = smoothie.getAttribute("data-flavor");
      if (quantity >= 0) {
        for (let item of PACK_SELECTION.pack_items) {
          console.log(item.flavor, flavor);
          if (item.flavor === flavor) {
            if (quantity > 0) {
              selection_container.innerHTML += `${item.flavor.replace(
                /^./,
                item.flavor[0].toUpperCase()
              )} (${item.quantity}) — `;
              // remove 2 last char of selection_container.innerHTML
              document
                .querySelector(".product-pack__selection")
                .classList.remove("hidden");
              console.log(selection_container);
            }
          }
        }
      }
    }

    selection_container.innerHTML = selection_container.innerHTML.slice(0, -2);
  }

  updateSmoothiesCounter() { }

  updateSelectionContent() {
    const quantity_inputs = document.querySelectorAll(
      ".product-pack__flavors--customize quantity-input"
    );
    console.log("in");
    // We update the pack selection object
    for (const input of quantity_inputs) {
      for (let item of PACK_SELECTION.pack_items) {
        // Update the quantity of each smoothie in the pack selection object
        if (item.flavor === input.querySelector("input").dataset.flavor) {
          item.quantity = parseInt(input.querySelector("input").value);
          console.log(item);
        }
      }
    }
  }
}

if (customElements.get("quantity-input") === undefined) {
  customElements.define("quantity-input", QuantityInput);
}

class ReccuringOption extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", this.selectOption.bind(this));

    if (this.dataset.subscribe === "true") {
      this.initEventSelectReccuring();
    } else {
      document.querySelector('[data-step="subscribe"]').classList.add("hidden");
      document
        .querySelector('[data-step="oneshot"]')
        .classList.remove("hidden");
    }

    // check if click outside .product-pack__recurring-select-values and close it
    document.addEventListener("click", (event) => {
      if (event.target.closest(".product-pack__recurring-select") === null) {
        this.querySelector(".product-pack__recurring-select-values")
          ? this.querySelector(
            ".product-pack__recurring-select-values"
          ).classList.add("hidden")
          : null;
        this.querySelector(".product-pack__recurring-select")
          ? this.querySelector(
            ".product-pack__recurring-select"
          ).classList.remove("actif")
          : null;
      }
    });
  }

  initEventSelectReccuring() {
    document
      .querySelector('[data-step="subscribe"]')
      .classList.remove("hidden");
    document.querySelector('[data-step="oneshot"]').classList.add("hidden");
    this.querySelectorAll(
      ".product-pack__recurring-current, .product-pack__recurring-select svg "
    ).forEach((select) => {
      select.addEventListener("click", (event) => {
        event.preventDefault();
        this.querySelector(
          ".product-pack__recurring-select-values"
        ).classList.toggle("hidden");
        this.querySelector(".product-pack__recurring-select").classList.toggle(
          "actif"
        );
      });
    });

    this.querySelectorAll(
      ".product-pack__recurring-select-values label"
    ).forEach((select) => {
      select.addEventListener("click", (event) => {
        event.preventDefault();
        this.querySelector(
          ".product-pack__recurring-current"
        ).innerHTML = `<span class="product-pack__recurring-current-value" data-selling-plan-id="${event.currentTarget
          .getAttribute("for")
          .replace("selling_plan_", "")}">${event.target.innerHTML}</span>`;
        this.querySelector(
          ".product-pack__recurring-select-values"
        ).classList.toggle("hidden");
        this.querySelector(".product-pack__recurring-select").classList.remove(
          "actif"
        );

        PACK_SELECTION.selling_plan_id = event.currentTarget
          .getAttribute("for")
          .replace("selling_plan_", "");

        document
          .querySelectorAll(".product-pack__recurring-select-values label")
          .forEach((label) => {
            label.classList.remove("actif");
            if (
              label.getAttribute("for") ===
              event.currentTarget.getAttribute("for")
            ) {
              label.classList.add("actif");
            }
          });
      });
    });
  }

  updatePriceCta() {
    const is_subscription = document.querySelector(
      '[data-subscribe="true"].actif'
    )
      ? true
      : false;

    if (is_subscription) {
      document.querySelector("[data-discover-price]").innerHTML =
        " - " + PACK_SELECTION.pack_price_sub.toFixed(2) + "€" + '<svg xmlns="http://www.w3.org/2000/svg" width="29" height="22" viewBox="0 0 29 22" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.5 4.78459C0.5 4.31659 0.881473 3.93719 1.35204 3.93719H4.41087C4.81352 3.93719 5.16121 4.21753 5.24449 4.60933L5.78504 7.15239H21.7438C22.0421 7.15239 22.3186 7.30749 22.4729 7.56132C22.6272 7.81516 22.6369 8.13076 22.4983 8.39344L18.0801 16.7699C17.933 17.0489 17.6423 17.2237 17.3256 17.2237H6.87481C6.47215 17.2237 6.12447 16.9434 6.04119 16.5516L3.72012 5.63199H1.35204C0.881473 5.63199 0.5 5.2526 0.5 4.78459ZM7.56556 15.5289H16.8104L20.3347 8.84719H6.14529L7.56556 15.5289Z" fill="white"/><path fill-rule="evenodd" clip-rule="evenodd" d="M8.35614 20.0235C8.35595 20.024 8.35547 20.0251 8.35547 20.0284C8.35547 20.0316 8.35595 20.0327 8.35614 20.0332L8.35616 20.0332C8.35656 20.0342 8.35752 20.0359 8.35934 20.0377C8.36116 20.0395 8.36285 20.0404 8.36381 20.0408L8.36386 20.0409C8.36429 20.041 8.36542 20.0415 8.3687 20.0415C8.37198 20.0415 8.37311 20.041 8.37354 20.0409L8.37358 20.0408C8.37455 20.0404 8.37623 20.0395 8.37805 20.0377C8.37987 20.0359 8.38083 20.0342 8.38124 20.0332L8.38126 20.0332C8.38144 20.0327 8.38192 20.0316 8.38192 20.0284C8.38192 20.0251 8.38144 20.024 8.38126 20.0235L8.38124 20.0235C8.38083 20.0225 8.37987 20.0209 8.37805 20.019C8.37623 20.0172 8.37455 20.0163 8.37358 20.0159L8.37354 20.0158C8.37311 20.0157 8.37198 20.0152 8.3687 20.0152C8.36542 20.0152 8.36429 20.0157 8.36386 20.0158L8.36381 20.0159C8.36285 20.0163 8.36116 20.0172 8.35934 20.019C8.35752 20.0209 8.35656 20.0225 8.35616 20.0235L8.35614 20.0235ZM6.64111 20.0284C6.64111 19.0782 7.41458 18.308 8.3687 18.308C9.32282 18.308 10.0963 19.0782 10.0963 20.0284C10.0963 20.9785 9.32282 21.7487 8.3687 21.7487C7.41458 21.7487 6.64111 20.9785 6.64111 20.0284Z" fill="white"/><path fill-rule="evenodd" clip-rule="evenodd" d="M15.5461 20.0235C15.5459 20.024 15.5454 20.0251 15.5454 20.0284C15.5454 20.0316 15.5459 20.0327 15.5461 20.0332L15.5461 20.0332C15.5465 20.0342 15.5475 20.0359 15.5493 20.0377C15.5511 20.0395 15.5528 20.0404 15.5538 20.0408L15.5538 20.0409C15.5542 20.041 15.5554 20.0415 15.5586 20.0415C15.5619 20.0415 15.563 20.041 15.5635 20.0409L15.5635 20.0408C15.5645 20.0404 15.5662 20.0395 15.568 20.0377C15.5698 20.0359 15.5708 20.0342 15.5712 20.0332L15.5712 20.0332C15.5714 20.0327 15.5719 20.0316 15.5719 20.0284C15.5719 20.0251 15.5714 20.024 15.5712 20.0235L15.5712 20.0235C15.5708 20.0225 15.5698 20.0209 15.568 20.019C15.5662 20.0172 15.5645 20.0163 15.5635 20.0159L15.5635 20.0158C15.563 20.0157 15.5619 20.0152 15.5586 20.0152C15.5554 20.0152 15.5542 20.0157 15.5538 20.0158L15.5538 20.0159C15.5528 20.0163 15.5511 20.0172 15.5493 20.019C15.5475 20.0209 15.5465 20.0225 15.5461 20.0235L15.5461 20.0235ZM13.8311 20.0284C13.8311 19.0782 14.6045 18.308 15.5586 18.308C16.5128 18.308 17.2862 19.0782 17.2862 20.0284C17.2862 20.9785 16.5128 21.7487 15.5586 21.7487C14.6045 21.7487 13.8311 20.9785 13.8311 20.0284Z" fill="white"/><ellipse cx="21.5939" cy="7.62591" rx="6.90595" ry="6.87713" fill="white"/><path d="M20.6984 10.7893V4.47949H22.4676V10.7893H20.6984ZM18.3257 8.46751V6.80129H24.8539V8.46751H18.3257Z" fill="#17433E"/></svg >';
    } else {
      document.querySelector("[data-discover-price]").innerHTML =
        " - " + PACK_SELECTION.pack_price + "€" + '<svg xmlns="http://www.w3.org/2000/svg" width="29" height="22" viewBox="0 0 29 22" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.5 4.78459C0.5 4.31659 0.881473 3.93719 1.35204 3.93719H4.41087C4.81352 3.93719 5.16121 4.21753 5.24449 4.60933L5.78504 7.15239H21.7438C22.0421 7.15239 22.3186 7.30749 22.4729 7.56132C22.6272 7.81516 22.6369 8.13076 22.4983 8.39344L18.0801 16.7699C17.933 17.0489 17.6423 17.2237 17.3256 17.2237H6.87481C6.47215 17.2237 6.12447 16.9434 6.04119 16.5516L3.72012 5.63199H1.35204C0.881473 5.63199 0.5 5.2526 0.5 4.78459ZM7.56556 15.5289H16.8104L20.3347 8.84719H6.14529L7.56556 15.5289Z" fill="white"/><path fill-rule="evenodd" clip-rule="evenodd" d="M8.35614 20.0235C8.35595 20.024 8.35547 20.0251 8.35547 20.0284C8.35547 20.0316 8.35595 20.0327 8.35614 20.0332L8.35616 20.0332C8.35656 20.0342 8.35752 20.0359 8.35934 20.0377C8.36116 20.0395 8.36285 20.0404 8.36381 20.0408L8.36386 20.0409C8.36429 20.041 8.36542 20.0415 8.3687 20.0415C8.37198 20.0415 8.37311 20.041 8.37354 20.0409L8.37358 20.0408C8.37455 20.0404 8.37623 20.0395 8.37805 20.0377C8.37987 20.0359 8.38083 20.0342 8.38124 20.0332L8.38126 20.0332C8.38144 20.0327 8.38192 20.0316 8.38192 20.0284C8.38192 20.0251 8.38144 20.024 8.38126 20.0235L8.38124 20.0235C8.38083 20.0225 8.37987 20.0209 8.37805 20.019C8.37623 20.0172 8.37455 20.0163 8.37358 20.0159L8.37354 20.0158C8.37311 20.0157 8.37198 20.0152 8.3687 20.0152C8.36542 20.0152 8.36429 20.0157 8.36386 20.0158L8.36381 20.0159C8.36285 20.0163 8.36116 20.0172 8.35934 20.019C8.35752 20.0209 8.35656 20.0225 8.35616 20.0235L8.35614 20.0235ZM6.64111 20.0284C6.64111 19.0782 7.41458 18.308 8.3687 18.308C9.32282 18.308 10.0963 19.0782 10.0963 20.0284C10.0963 20.9785 9.32282 21.7487 8.3687 21.7487C7.41458 21.7487 6.64111 20.9785 6.64111 20.0284Z" fill="white"/><path fill-rule="evenodd" clip-rule="evenodd" d="M15.5461 20.0235C15.5459 20.024 15.5454 20.0251 15.5454 20.0284C15.5454 20.0316 15.5459 20.0327 15.5461 20.0332L15.5461 20.0332C15.5465 20.0342 15.5475 20.0359 15.5493 20.0377C15.5511 20.0395 15.5528 20.0404 15.5538 20.0408L15.5538 20.0409C15.5542 20.041 15.5554 20.0415 15.5586 20.0415C15.5619 20.0415 15.563 20.041 15.5635 20.0409L15.5635 20.0408C15.5645 20.0404 15.5662 20.0395 15.568 20.0377C15.5698 20.0359 15.5708 20.0342 15.5712 20.0332L15.5712 20.0332C15.5714 20.0327 15.5719 20.0316 15.5719 20.0284C15.5719 20.0251 15.5714 20.024 15.5712 20.0235L15.5712 20.0235C15.5708 20.0225 15.5698 20.0209 15.568 20.019C15.5662 20.0172 15.5645 20.0163 15.5635 20.0159L15.5635 20.0158C15.563 20.0157 15.5619 20.0152 15.5586 20.0152C15.5554 20.0152 15.5542 20.0157 15.5538 20.0158L15.5538 20.0159C15.5528 20.0163 15.5511 20.0172 15.5493 20.019C15.5475 20.0209 15.5465 20.0225 15.5461 20.0235L15.5461 20.0235ZM13.8311 20.0284C13.8311 19.0782 14.6045 18.308 15.5586 18.308C16.5128 18.308 17.2862 19.0782 17.2862 20.0284C17.2862 20.9785 16.5128 21.7487 15.5586 21.7487C14.6045 21.7487 13.8311 20.9785 13.8311 20.0284Z" fill="white"/><ellipse cx="21.5939" cy="7.62591" rx="6.90595" ry="6.87713" fill="white"/><path d="M20.6984 10.7893V4.47949H22.4676V10.7893H20.6984ZM18.3257 8.46751V6.80129H24.8539V8.46751H18.3257Z" fill="#17433E"/></svg >';
    }
  }

  selectOption(event) {
    if (this.dataset.subscribe === "true") {
      document.querySelector(
        'pack-item:not([data-discover-pack="true"]) [data-unit-price-sub]'
      )
        ? document
          .querySelectorAll(
            'pack-item:not([data-discover-pack="true"]) [data-unit-price-sub]'
          )
          .forEach((price) => {
            price.classList.remove("hidden");
          })
        : null;
      document.querySelector(
        'pack-item:not([data-discover-pack="true"]) [data-unit-price-oneshot]'
      )
        ? document
          .querySelectorAll(
            'pack-item:not([data-discover-pack="true"]) [data-unit-price-oneshot]'
          )
          .forEach((price) => {
            price.classList.add("hidden");
          })
        : null;
    } else {
      document.querySelector(
        'pack-item:not([data-discover-pack="true"]) [data-unit-price-sub]'
      )
        ? document
          .querySelectorAll(
            'pack-item:not([data-discover-pack="true"]) [data-unit-price-sub]'
          )
          .forEach((price) => {
            price.classList.add("hidden");
          })
        : null;
      document.querySelector(
        'pack-item:not([data-discover-pack="true"]) [data-unit-price-oneshot]'
      )
        ? document
          .querySelectorAll(
            'pack-item:not([data-discover-pack="true"]) [data-unit-price-oneshot]'
          )
          .forEach((price) => {
            price.classList.remove("hidden");
          })
        : null;
    }
    document.querySelectorAll("recurring-option").forEach((option) => {
      option.classList.remove("actif");
    });
    this.classList.add("actif");

    const select = document
      .querySelector(".rb-select [data-selling-plan-id]")
      .closest("select");

    if (this.dataset.subscribe === "true") {
      PACK_SELECTION.selling_plan_id === undefined
        ? (PACK_SELECTION.selling_plan_id = document.querySelector(
          ".product-pack__recurring-select-values input:checked"
        ).value)
        : null;
      select.selectedIndex = document.querySelector(
        `.rb-select [data-selling-plan-id="${PACK_SELECTION.selling_plan_id}"]`
      ).index;
    } else {
      select.selectedIndex = 0;
    }

    select.dispatchEvent(new Event("change"));

    if (document.querySelector(".product-sub__top-bar")) {
      document.querySelector(".top-bar__recuring").innerHTML =
        document.querySelector(
          ".product-pack__recurring-select-values .actif"
        ).innerHTML;
    }

    this.updatePriceCta();
  }
}

if (customElements.get("recurring-option") === undefined) {
  customElements.define("recurring-option", ReccuringOption);
}

class flavorPopup extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", this.openPopup.bind(this));
    this.popup = document.querySelector(".popup-flavor");
    this.template = document.querySelector(".popup-flavor__template");
    document
      .querySelector(".popup-flavor__close")
      .addEventListener("click", () => {
        document.querySelector(".popup-container").classList.remove("opened");
        document.querySelector(".popup-container").classList.remove("loading");
        document.querySelector("body").classList.remove("no-scroll");
      });

    // close popup if click outside of popup
    document
      .querySelector(".popup-container")
      .addEventListener("mousedown", (event) => {
        if (event.target.classList.contains("popup-container")) {
          document.querySelector(".popup-container").classList.remove("opened");
          document
            .querySelector(".popup-container")
            .classList.remove("loading");
          document.querySelector("body").classList.remove("no-scroll");
        }
      });
  }

  openPopup(event) {
    document.querySelector(".popup-container").classList.add("opened");
    document.querySelector(".popup-container").classList.add("loading");
    document.querySelector("body").classList.add("no-scroll");

    fetch("/products/" + this.dataset.open + "?view=default")
      .then((response) => {
        return response.text();
      })
      .then((data) => {
        let new_data =
          "<main" + data.split("<main")[1].split("</main>")[0] + "</main>";
        this.template.innerHTML = new_data.replace("#wave1", "#wave023");
        document.querySelector(".popup-container").classList.remove("loading");
        document
          .querySelector(
            '.popup-container [data-section-type="product-ingredients"]'
          )
          .classList.remove("hidden");
        document
          .querySelector(
            '.popup-container [data-popup-open="product-information"]'
          )
          .classList.add("hidden");

        scrollCash();
      });
  }
}

if (customElements.get("flavor-popup") === undefined) {
  customElements.define("flavor-popup", flavorPopup);
}

const scrollCash = () => {
  const sliderTouch = document.querySelectorAll(
    ".popup-flavor .main-product-medias, .popup-flavor .product-ingredients__items-v2"
  );
  let isDown = false;
  let startX;
  let scrollLeft;

  document
    .querySelectorAll(
      ".popup-container .main-product-medias__other img, .popup-flavor .product-ingredients__items-v2 img"
    )
    .forEach((img) => {
      img.ondragstart = function () {
        return false;
      };
    });

  for (let slider of sliderTouch) {
    slider.addEventListener("mousedown", (e) => {
      isDown = true;
      slider.classList.add("active");
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
    });
    slider.addEventListener("mouseleave", () => {
      isDown = false;
      slider.classList.remove("active");
    });
    slider.addEventListener("mouseup", () => {
      isDown = false;
      slider.classList.remove("active");
    });
    slider.addEventListener("mousemove", (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - slider.offsetLeft;
      const walk = x - startX;
      slider.scrollLeft = scrollLeft - walk;
    });
  }
};

window.addEventListener("load", () => {
  if (window.location.href.indexOf("/pages") > -1) {
    // document.querySelector('[data-discover-pack="true"]').click();
  }
  function setSectionHeight() {
    let totalHeight = 0;
    let elements = [
      document.querySelector(".main-product"),
      document.querySelector(".sub-icon-text"),
      document.querySelector(".faq__container"),
    ];

    elements.forEach((el) => {
      if (el) {
        totalHeight += el.offsetHeight;
      }
    });

    totalHeight += 50;

    document.documentElement.style.setProperty(
      "--sub-sections-height",
      `${totalHeight}px`
    );
  }

  setSectionHeight();

  if (document.querySelector(".product-subscription")) {
    document
      .querySelector('[data-product-name="Pack de 20 Smoothies"]')
      .click();
  }

  window.addEventListener("resize", setSectionHeight);
});


class QuantityInputMain extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.quantityInput = this.querySelector('[data-quantity-input]');
    // change quantity on click minus button 

    this.querySelector('[data-action="decrement"]').addEventListener('click', () => {
      let value = parseInt(this.quantityInput.value, 10);
      if (value > 1) {
        this.quantityInput.value = value - 1;
        this.quantityInput.dispatchEvent(new Event('input'));
      }

      if (this.quantityInput.value == 1) {
        this.querySelector('[data-action="decrement"]').disabled = true;
      }

      document.querySelector('[data-discover-price]').textContent = "- " + PACK_SELECTION.pack_price * this.quantityInput.value + '€';

    });

    // change quantity on click plus button

    this.querySelector('[data-action="increment"]').addEventListener('click', () => {
      let value = parseInt(this.quantityInput.value, 10);
      this.quantityInput.value = value + 1;
      this.querySelector('[data-action="decrement"]').disabled = false;
      this.quantityInput.dispatchEvent(new Event('input'));
      document.querySelector('[data-discover-price]').textContent = '- ' + PACK_SELECTION.pack_price * this.quantityInput.value + '€';
    });

  }
}

customElements.define('quantity-input-main', QuantityInputMain);